import {CommonMessages} from '../common.messages';

export const PanelAccountsEditFeePlansMessages = {
    GetFeeGroupsFailed: {
        key: 'GetFeeGroupsFailed',
        message: 'Error while communication with the server. Unable to get all fee categories.'
    },
    GetFeeGroupsNotFound: {
        key: 'GetFeeGroupsNotFound',
        message: 'Error while communication with the server. Unable to find fee categories.'
    },
    GetFeeTypesFailed: {
        key: 'GetFeeTypesFailed',
        message: 'Error while communication with the server. Unable to get all fee plans.'
    },
    GetFeeTypesNotFound: {
        key: 'GetFeeTypesNotFound',
        message: 'Error while communication with the server. Unable to find fee plans.'
    },
    FeeGroupsNotFound: {
        key: 'FeeGroupsNotFound',
        message: 'Fee categories not found.'
    },
    FeeTypesMissingInGroup: {
        key: 'FeeTypesMissingInGroup',
        message: 'Fee category doesn\'t contain fee plans.'
    },
    UnAssignFeeConfirmationDialogCaption: {
        key: 'UnAssignFeeConfirmationDialogCaption',
        message: 'Fee Unassignment'
    },
    UnAssignFeeConfirmationDialogQuestion: {
        key: 'UnAssignFeeConfirmationDialogQuestion',
        message: 'Are you sure you want to unassign <<fee>> for account <<account>>?'
    },
    UnAssignFeeFromAccountFailed: {
        key: 'UnAssignFeeFromAccountFailed',
        message: '<<fee>> fee unassignment for account <<account>> failed.'
    },
    ...CommonMessages
};
